import React, { useState } from "react";
import Layout from "../Components/Layout";
import { Container, Row, Col, FormControl } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import i18n, { changeLanguage } from "i18next";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import LayoutNew from "../Components/LayoutNew";
import {
  cancelAppointment,
  getUserAppointments,
} from "../Redux/Actions/userActions";
import { useMutation, useQuery } from "@tanstack/react-query";
import { appointmentList } from "../Redux/Reducers/appointmentSlice";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import {
  appointmentData,
  appointmentID,
  coachDetails,
} from "../Redux/Reducers/CoachSlice";

export default function Appointments() {
  const dispatch = useDispatch();
  const BASE_URL = "https://api.mindrepublic.com/";
  const navigate = useNavigate();

  // // ======================================check for language=======================================

  const ingerman = useSelector((state) => state.homedata.selectedLang);
  console.log(ingerman);

  // ================================================react State================================================

  const [type, setType] = useState("1");
  const [show, setshow] = useState(false);

  // =================================================get list of appointments=====================================

  const { isPending, data, isSuccess, isError } = useQuery({
    queryKey: ["appointmentList", type],
    queryFn: () => getUserAppointments(type),
  });

  {
    isSuccess && dispatch(appointmentList(data));
  }

  {
    isError && toast.error(data?.message || "Something went wrong");
  }

  console.log(data, "data");

  // =================================================post=====================================

  // const { isPending: cancel, mutate } = useMutation({
  //   mutationFn: cancelAppointment,
  //   onSuccess: (res) => {
  //     console.log(res);
  //     if (res?.success) {
  //       toast.success(res?.message);
  //       navigate("/dashboard");
  //     }else{
  //       toast?.error(res?.message)
  //     }
  //   },
  //   onError: (res) => {
  //     toast.error(res?.message);
  //   },
  // });

  const handlePayment = (status, id, coachdetails) => {
    console.log(coachdetails, "==================================");
    console.log(id, "==================================");
    console.log(status, "==================================");

    dispatch(appointmentID(id));
    dispatch(coachDetails(coachdetails));
    dispatch(appointmentData(coachdetails?.timeSlot));
    console.log(status, "status");
    if (status == 1 || status == 3) {
      navigate("/invoice-details");
    }
  };

  // const cancelAppointmentRefund = (id) => {
  //   console.log("cancel")
  //   mutate({
  //     appointment_id: id,
  //     langType: ingerman == "de" ? 1 : 0,
  //   });
  // };

  return (
    <>
      <LayoutNew>
        <div style={{ position: "relative" }} className="right-side">
          {isPending && (
            <div
              style={{
                position: "absolute",
                width: "110%",
                height: "100%",
                zIndex: "1",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                // backgroundColor: "rgba(0,0,0,0.1)",
              }}
            >
              <div class="loader"></div>
            </div>
          )}

          <div className="main-content">
            <h2>{ingerman=="de" ?"Meine Termine" : "Appointments"}</h2>
            <div className="appointments-list-box">
              <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                <Row>
                  <Col sm={12}>
                    <Nav variant="pills" className="appointments-tabs">
                      <Nav.Item>
                        <Nav.Link
                          onClick={() => setType("1")}
                          eventKey="first"
                        >
                         {ingerman=="de" ? "Aktuell" : "Current"} 
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link onClick={() => setType("0")} eventKey="second">
                         {ingerman=="de" ? "Vergangenheit" : "Past"} 
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Col>
                  <Col sm={12}>
                    <Tab.Content>
                      <Tab.Pane eventKey="second">
                        <div className="coaching-listing">
                          {data?.data?.length > 0 ? (
                            data?.data?.map((appointment) => {
                              return (
                                <div className="coaching-card-item">
                                  <div className="coach-img-detail">
                                    <img
                                      // style={{ cursor: "pointer" }}
                                      // onClick={() =>
                                      //   // navigate("/requested-details",
                                      //   // {
                                      //   //   state: {
                                      //   //     img: appointment?.coach_id
                                      //   //       ?.profile_image,
                                      //   //     name: appointment?.coach_id
                                      //   //       ?.full_name,
                                      //   //     createdAt: appointment?.createdAt,
                                      //   //     country_code:
                                      //   //       appointment?.coach_id
                                      //   //         ?.country_code,
                                      //   //     phone_number:
                                      //   //       appointment?.coach_id
                                      //   //         ?.phone_number,
                                      //   //     slot: appointment?.timeSlot,
                                      //   //     status: appointment?.status,
                                      //   //     coachDetails:
                                      //   //       appointment?.coach_id,
                                      //   //     appointmentId: appointment?._id,
                                      //   //   },
                                      //   // }
                                      //   // )

                                      // }
                                      src={
                                        appointment?.coach_id?.profile_image
                                          ? `${BASE_URL}${appointment?.coach_id?.profile_image}`
                                          : require("../Assets/images/place_holder.png")
                                      }
                                    />
                                    <div className="coach-card-info">
                                      <h3>
                                        {appointment?.coach_id?.full_name}
                                      </h3>
                                      <p>{appointment?.coach_id?.address}</p>
                                      <p className="coach-date">
                                        <span>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="17"
                                            height="17"
                                            viewBox="0 0 17 17"
                                            fill="none"
                                          >
                                            <g clip-path="url(#clip0_4325_19163)">
                                              <path
                                                d="M13.4249 1.78416V2.03416H13.6749H14.1495C15.5236 2.03416 16.6419 3.15244 16.6419 4.52657V4.54596V4.56533V4.5847V4.60405V4.62338V4.64271V4.66202V4.68132V4.7006V4.71988V4.73914V4.75839V4.77762V4.79685V4.81606V4.83526V4.85444V4.87362V4.89278V4.91193V4.93107V4.9502V4.96931V4.98842V5.00751V5.02659V5.04565V5.06471V5.08376V5.10279V5.12181V5.14082V5.15982V5.1788V5.19778V5.21674V5.23569V5.25463V5.27356V5.29248V5.31139V5.33029V5.34917V5.36805V5.38691V5.40576V5.4246V5.44343V5.46225V5.48106V5.49986V5.51865V5.53743V5.55619V5.57495V5.59369V5.61243V5.63115V5.64987V5.66857V5.68727V5.70595V5.72462V5.74329V5.76194V5.78058V5.79922V5.81784V5.83645V5.85506V5.87365V5.89223V5.91081V5.92937V5.94793V5.96647V5.98501V6.00353V6.02205V6.04056V6.05906V6.07754V6.09602V6.11449V6.13295V6.15141V6.16985V6.18828V6.20671V6.22512V6.24353V6.26193V6.28032V6.2987V6.31707V6.33543V6.35378V6.37213V6.39047V6.40879V6.42711V6.44543V6.46373V6.48202V6.50031V6.51859V6.53686V6.55512V6.57337V6.59162V6.60986V6.62809V6.64631V6.66452V6.68273V6.70092V6.71912V6.7373V6.75547V6.77364V6.7918V6.80995V6.8281V6.84623V6.86436V6.88248V6.9006V6.91871V6.93681V6.9549V6.97299V6.99107V7.00914V7.0272V7.04526V7.06331V7.08136V7.09939V7.11742V7.13545V7.15346V7.17147V7.18948V7.20748V7.22547V7.24345V7.26143V7.2794V7.29736V7.31532V7.33328V7.35122V7.36916V7.3871V7.40502V7.42295V7.44086V7.45877V7.47668V7.49457V7.51247V7.53035V7.54823V7.56611V7.58398V7.60184V7.6197V7.63755V7.6554V7.67324V7.69108V7.70891V7.72674V7.74456V7.76237V7.78018V7.79799V7.81579V7.83358V7.85137V7.86916V7.88694V7.90471V7.92249V7.94025V7.95801V7.97577V7.99352V8.01127V8.02901V8.04675V8.06448V8.08221V8.09994V8.11766V8.13538V8.15309V8.1708V8.1885V8.2062V8.2239V8.24159V8.25928V8.27696V8.29464V8.31232V8.32999V8.34766V8.36533V8.38299V8.40065V8.4183V8.43595V8.4536V8.47124V8.48889V8.50652V8.52416V8.54179V8.55942V8.57704V8.59466V8.61228V8.6299V8.64751V8.66512V8.68272V8.70033V8.71793V8.73553V8.75312V8.77072V8.78831V8.80589V8.82348V8.84106V8.85864V8.87622V8.8938V8.91137V8.92894V8.94651V8.96408V8.98164V8.9992V9.01676V9.03432V9.05188V9.06943V9.08699V9.10454V9.12209V9.13963V9.15718V9.17472V9.19227V9.20981V9.22735V9.24488V9.26242V9.27995V9.29749V9.31502V9.33255V9.35008V9.36761V9.38514V9.40267V9.42019V9.43772V9.45524V9.47276V9.49029V9.50781V9.52533V9.54285V9.56037V9.57789V9.5954V9.61292V9.63044V9.64795V9.66547V9.68299V9.7005V9.71802V9.73553V9.75305V9.77056V9.78808V9.80559V9.82311V9.84062V9.85814V9.87565V9.89317V9.91068V9.9282V9.94571V9.96323V9.98075V9.99826V10.0158V10.0333V10.0508V10.0683V10.0859V10.1034V10.1209V10.1384V10.1559V10.1735V10.191V10.2085V10.226V10.2436V10.2611V10.2786V10.2962V10.3137V10.3312V10.3488V10.3663V10.3838V10.4014V10.4189V10.4365V10.454V10.4716V10.4891V10.5067V10.5242V10.5418V10.5593V10.5769V10.5944V10.612V10.6296V10.6471V10.6647V10.6823V10.6998V10.7174V10.735V10.7526V10.7701V10.7877V10.8053V10.8229V10.8405V10.8581V10.8757V10.8933V10.9109V10.9285V10.9461V10.9637V10.9813V10.9989V11.0165V11.0342V11.0518V11.0694V11.0871V11.1047V11.1223V11.14V11.1576V11.1753V11.1929V11.2106V11.2282V11.2459V11.2636V11.2812V11.2989V11.3166V11.3343V11.3519V11.3696V11.3873V11.405V11.4227V11.4404V11.4581V11.4759V11.4936V11.5113V11.529V11.5468V11.5645V11.5822V11.6V11.6177V11.6355V11.6532V11.671V11.6888V11.7065V11.7243V11.7421V11.7599V11.7777V11.7955V11.8133V11.8311V11.8489V11.8667V11.8845V11.9024V11.9202V11.938V11.9559V11.9737V11.9916V12.0094V12.0273V12.0452V12.063V12.0809V12.0988V12.1167V12.1346V12.1525V12.1704V12.1883V12.2063V12.2242V12.2421V12.2601V12.278V12.296V12.3139V12.3319V12.3499V12.3679V12.3858V12.4038V12.4218V12.4398V12.4578V12.4759V12.4939V12.5119V12.53V12.548V12.5661V12.5841V12.6022V12.6203V12.6383V12.6564V12.6745V12.6926V12.7107V12.7289V12.747V12.7651V12.7832V12.8014V12.8196V12.8377V12.8559V12.8741V12.8922V12.9104V12.9286V12.9468V12.9651V12.9833V13.0015V13.0198V13.038V13.0563V13.0745V13.0928V13.1111V13.1294V13.1477V13.166V13.1843V13.2026V13.2209V13.2393V13.2576V13.276V13.2943V13.3127V13.3311V13.3495V13.3679V13.3863V13.4047V13.4231V13.4416V13.46V13.4785V13.4969V13.5154V13.5339V13.5524V13.5709V13.5894V13.6079V13.6264V13.645V13.6635V13.6821V13.7006V13.7192V13.7378V13.7564C16.6419 15.1309 15.5232 16.2496 14.1486 16.2496H2.85063C1.4761 16.2496 0.357422 15.1309 0.357422 13.7564V4.52657C0.357422 3.15243 1.47574 2.03412 2.84973 2.03412H3.32431H3.57431V1.78412V1.62727C3.57431 1.14482 3.96716 0.751953 4.44966 0.751953C4.93216 0.751953 5.32501 1.14481 5.32501 1.62731V1.78416V2.03416H5.57501H11.4242H11.6742V1.78416V1.62731C11.6742 1.14481 12.0671 0.751953 12.5496 0.751953C13.0321 0.751953 13.4249 1.14481 13.4249 1.62731V1.78416ZM0.631932 6.33367H0.381932V6.58367V13.7564C0.381932 15.118 1.48913 16.2251 2.85063 16.2251H14.1486C15.5101 16.2251 16.6174 15.118 16.6174 13.7564L16.6174 6.58367L16.6174 6.33367H16.3674H0.631932ZM16.3674 6.30863H16.6174V6.05863V4.52657C16.6174 3.1656 15.5105 2.05867 14.1495 2.05867H13.6749H13.4249V2.30867V2.46542C13.4249 2.94792 13.0321 3.34077 12.5496 3.34077C12.0671 3.34077 11.6742 2.94791 11.6742 2.46542V2.30867V2.05867H11.4242H5.57505H5.32505V2.30867V2.46542C5.32505 2.94792 4.93219 3.34077 4.44969 3.34077C3.9672 3.34077 3.57434 2.94792 3.57434 2.46542V2.30867V2.05867H3.32434H2.84977C1.48874 2.05867 0.381965 3.16558 0.381965 4.52657V6.05863V6.30863H0.631965H16.3674ZM12.5496 0.77643C12.0802 0.77643 11.6987 1.15794 11.6987 1.62727V2.46539C11.6987 2.93477 12.0802 3.31623 12.5496 3.31623C13.0189 3.31623 13.4004 2.93472 13.4004 2.46539V1.62727C13.4004 1.15789 13.0189 0.77643 12.5496 0.77643ZM4.44969 0.77643C3.98031 0.77643 3.59885 1.15794 3.59885 1.62727V2.46539C3.59885 2.93476 3.98032 3.31623 4.44969 3.31623C4.91907 3.31623 5.30054 2.93472 5.30054 2.46539V1.62727C5.30054 1.1579 4.91906 0.77643 4.44969 0.77643Z"
                                                fill="#014D3C"
                                                stroke="#7E7E7E"
                                                stroke-width="0.5"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_4325_19163">
                                                <rect
                                                  width="17"
                                                  height="17"
                                                  fill="white"
                                                />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                        </span>
                                        {appointment?.timeSlot}
                                      </p>

                                      <div
                                      // onClick={
                                      //   () =>
                                      //   handlePayment(
                                      //     appointment?.status,
                                      //     appointment?._id,
                                      //     appointment
                                      //   )
                                      // }
                                      style={{ width: ingerman === "en"? "200px" : "300px" }}
                                      >
                                        <div
                                        className="leave-review"
                                        style={{cursor:"pointer"}}
                                        // to="/leave-review"
                                        onClick={()=>{
                                          appointment.reviewed==0 ?
                                          navigate("/leave-review",{state:{
                                            coachId:appointment?.coach_id?._id,
                                            appId:appointment?._id
                                          }}):toast.error("Review already exist for this appointment")
                                        }}
                                        >
                                          {/* {appointment?.status == 0
                                              ? "Not Accepted"
                                              : appointment?.status == 1
                                              ? "Pay"
                                              : appointment?.status == 2
                                              ? "Rejected"
                                              : appointment?.status == 3
                                              ? "Pay"
                                              : appointment?.status == 4
                                              ? "Cancel Request"
                                              : "Cancel Request"} */}
                                         {ingerman=="de" ? "Eine Rezension hinterlassen" : "Leave Review"} 
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="coach-rate">
                                    <p>
                                      <span>
                                        {appointment?.coach_id?.reviews == 0 ? (
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="22"
                                            height="23"
                                            viewBox="0 0 22 23"
                                            fill="none"
                                          >
                                            <path
                                              d="M11.0002 2.33398L13.8327 8.07232L20.1668 8.99815L15.5835 13.4623L16.6652 19.769L11.0002 16.7898L5.33516 19.769L6.41683 13.4623L1.8335 8.99815L8.16766 8.07232L11.0002 2.33398Z"
                                              fill="#A2AA96"
                                            />
                                          </svg>
                                        ) : (
                                          <svg
                                            width="19"
                                            height="18"
                                            viewBox="0 0 19 18"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M9.16667 0L11.9992 5.73833L18.3333 6.66417L13.75 11.1283L14.8317 17.435L9.16667 14.4558L3.50167 17.435L4.58333 11.1283L0 6.66417L6.33417 5.73833L9.16667 0Z"
                                              fill="#E5A151"
                                            />
                                          </svg>
                                        )}
                                      </span>
                                      {appointment?.coach_id?.reviews}
                                    </p>
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <p
                              style={{
                                textAlign: "center",
                                marginTop: "100px",
                              }}
                            >
                              {ingerman=="de" ? "Keine Daten gefunden" : "Data not found"}
                            </p>
                          )}
                        </div>
                      </Tab.Pane>

                      <Tab.Pane eventKey="first">
                        <div
                          // onClick={setshow}
                          // style={{ cursor: "pointer" }}
                          className="coaching-listing"
                        >
                          {data?.data?.length > 0 ? (
                            data?.data?.map((appointment) => {
                              return (
                                <div className="coaching-card-item">
                                  <div className="coach-img-detail">
                                    <img
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        navigate("/requested-details", {
                                          state: {
                                            img: appointment?.coach_id
                                              ?.profile_image,
                                            name: appointment?.coach_id
                                              ?.full_name,
                                            createdAt: appointment?.date,
                                            country_code:
                                              appointment?.coach_id
                                                ?.country_code,
                                            phone_number:
                                              appointment?.coach_id
                                                ?.phone_number,
                                            slot: appointment?.timeSlot,
                                            status: appointment?.status,
                                            coachDetails: appointment?.coach_id,
                                            appointmentId: appointment?._id,
                                          },
                                        })
                                      }
                                      src={
                                        appointment?.coach_id?.profile_image
                                          ? `${BASE_URL}${appointment?.coach_id?.profile_image}`
                                          : require("../Assets/images/place_holder.png")
                                      }
                                    />
                                    <div className="coach-card-info">
                                      <h3>
                                        {appointment?.coach_id?.full_name}
                                      </h3>
                                      <p>{appointment?.coach_id?.address}</p>
                                      <p className="coach-date">
                                        <span>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="17"
                                            height="17"
                                            viewBox="0 0 17 17"
                                            fill="none"
                                          >
                                            <g clip-path="url(#clip0_4325_19163)">
                                              <path
                                                d="M13.4249 1.78416V2.03416H13.6749H14.1495C15.5236 2.03416 16.6419 3.15244 16.6419 4.52657V4.54596V4.56533V4.5847V4.60405V4.62338V4.64271V4.66202V4.68132V4.7006V4.71988V4.73914V4.75839V4.77762V4.79685V4.81606V4.83526V4.85444V4.87362V4.89278V4.91193V4.93107V4.9502V4.96931V4.98842V5.00751V5.02659V5.04565V5.06471V5.08376V5.10279V5.12181V5.14082V5.15982V5.1788V5.19778V5.21674V5.23569V5.25463V5.27356V5.29248V5.31139V5.33029V5.34917V5.36805V5.38691V5.40576V5.4246V5.44343V5.46225V5.48106V5.49986V5.51865V5.53743V5.55619V5.57495V5.59369V5.61243V5.63115V5.64987V5.66857V5.68727V5.70595V5.72462V5.74329V5.76194V5.78058V5.79922V5.81784V5.83645V5.85506V5.87365V5.89223V5.91081V5.92937V5.94793V5.96647V5.98501V6.00353V6.02205V6.04056V6.05906V6.07754V6.09602V6.11449V6.13295V6.15141V6.16985V6.18828V6.20671V6.22512V6.24353V6.26193V6.28032V6.2987V6.31707V6.33543V6.35378V6.37213V6.39047V6.40879V6.42711V6.44543V6.46373V6.48202V6.50031V6.51859V6.53686V6.55512V6.57337V6.59162V6.60986V6.62809V6.64631V6.66452V6.68273V6.70092V6.71912V6.7373V6.75547V6.77364V6.7918V6.80995V6.8281V6.84623V6.86436V6.88248V6.9006V6.91871V6.93681V6.9549V6.97299V6.99107V7.00914V7.0272V7.04526V7.06331V7.08136V7.09939V7.11742V7.13545V7.15346V7.17147V7.18948V7.20748V7.22547V7.24345V7.26143V7.2794V7.29736V7.31532V7.33328V7.35122V7.36916V7.3871V7.40502V7.42295V7.44086V7.45877V7.47668V7.49457V7.51247V7.53035V7.54823V7.56611V7.58398V7.60184V7.6197V7.63755V7.6554V7.67324V7.69108V7.70891V7.72674V7.74456V7.76237V7.78018V7.79799V7.81579V7.83358V7.85137V7.86916V7.88694V7.90471V7.92249V7.94025V7.95801V7.97577V7.99352V8.01127V8.02901V8.04675V8.06448V8.08221V8.09994V8.11766V8.13538V8.15309V8.1708V8.1885V8.2062V8.2239V8.24159V8.25928V8.27696V8.29464V8.31232V8.32999V8.34766V8.36533V8.38299V8.40065V8.4183V8.43595V8.4536V8.47124V8.48889V8.50652V8.52416V8.54179V8.55942V8.57704V8.59466V8.61228V8.6299V8.64751V8.66512V8.68272V8.70033V8.71793V8.73553V8.75312V8.77072V8.78831V8.80589V8.82348V8.84106V8.85864V8.87622V8.8938V8.91137V8.92894V8.94651V8.96408V8.98164V8.9992V9.01676V9.03432V9.05188V9.06943V9.08699V9.10454V9.12209V9.13963V9.15718V9.17472V9.19227V9.20981V9.22735V9.24488V9.26242V9.27995V9.29749V9.31502V9.33255V9.35008V9.36761V9.38514V9.40267V9.42019V9.43772V9.45524V9.47276V9.49029V9.50781V9.52533V9.54285V9.56037V9.57789V9.5954V9.61292V9.63044V9.64795V9.66547V9.68299V9.7005V9.71802V9.73553V9.75305V9.77056V9.78808V9.80559V9.82311V9.84062V9.85814V9.87565V9.89317V9.91068V9.9282V9.94571V9.96323V9.98075V9.99826V10.0158V10.0333V10.0508V10.0683V10.0859V10.1034V10.1209V10.1384V10.1559V10.1735V10.191V10.2085V10.226V10.2436V10.2611V10.2786V10.2962V10.3137V10.3312V10.3488V10.3663V10.3838V10.4014V10.4189V10.4365V10.454V10.4716V10.4891V10.5067V10.5242V10.5418V10.5593V10.5769V10.5944V10.612V10.6296V10.6471V10.6647V10.6823V10.6998V10.7174V10.735V10.7526V10.7701V10.7877V10.8053V10.8229V10.8405V10.8581V10.8757V10.8933V10.9109V10.9285V10.9461V10.9637V10.9813V10.9989V11.0165V11.0342V11.0518V11.0694V11.0871V11.1047V11.1223V11.14V11.1576V11.1753V11.1929V11.2106V11.2282V11.2459V11.2636V11.2812V11.2989V11.3166V11.3343V11.3519V11.3696V11.3873V11.405V11.4227V11.4404V11.4581V11.4759V11.4936V11.5113V11.529V11.5468V11.5645V11.5822V11.6V11.6177V11.6355V11.6532V11.671V11.6888V11.7065V11.7243V11.7421V11.7599V11.7777V11.7955V11.8133V11.8311V11.8489V11.8667V11.8845V11.9024V11.9202V11.938V11.9559V11.9737V11.9916V12.0094V12.0273V12.0452V12.063V12.0809V12.0988V12.1167V12.1346V12.1525V12.1704V12.1883V12.2063V12.2242V12.2421V12.2601V12.278V12.296V12.3139V12.3319V12.3499V12.3679V12.3858V12.4038V12.4218V12.4398V12.4578V12.4759V12.4939V12.5119V12.53V12.548V12.5661V12.5841V12.6022V12.6203V12.6383V12.6564V12.6745V12.6926V12.7107V12.7289V12.747V12.7651V12.7832V12.8014V12.8196V12.8377V12.8559V12.8741V12.8922V12.9104V12.9286V12.9468V12.9651V12.9833V13.0015V13.0198V13.038V13.0563V13.0745V13.0928V13.1111V13.1294V13.1477V13.166V13.1843V13.2026V13.2209V13.2393V13.2576V13.276V13.2943V13.3127V13.3311V13.3495V13.3679V13.3863V13.4047V13.4231V13.4416V13.46V13.4785V13.4969V13.5154V13.5339V13.5524V13.5709V13.5894V13.6079V13.6264V13.645V13.6635V13.6821V13.7006V13.7192V13.7378V13.7564C16.6419 15.1309 15.5232 16.2496 14.1486 16.2496H2.85063C1.4761 16.2496 0.357422 15.1309 0.357422 13.7564V4.52657C0.357422 3.15243 1.47574 2.03412 2.84973 2.03412H3.32431H3.57431V1.78412V1.62727C3.57431 1.14482 3.96716 0.751953 4.44966 0.751953C4.93216 0.751953 5.32501 1.14481 5.32501 1.62731V1.78416V2.03416H5.57501H11.4242H11.6742V1.78416V1.62731C11.6742 1.14481 12.0671 0.751953 12.5496 0.751953C13.0321 0.751953 13.4249 1.14481 13.4249 1.62731V1.78416ZM0.631932 6.33367H0.381932V6.58367V13.7564C0.381932 15.118 1.48913 16.2251 2.85063 16.2251H14.1486C15.5101 16.2251 16.6174 15.118 16.6174 13.7564L16.6174 6.58367L16.6174 6.33367H16.3674H0.631932ZM16.3674 6.30863H16.6174V6.05863V4.52657C16.6174 3.1656 15.5105 2.05867 14.1495 2.05867H13.6749H13.4249V2.30867V2.46542C13.4249 2.94792 13.0321 3.34077 12.5496 3.34077C12.0671 3.34077 11.6742 2.94791 11.6742 2.46542V2.30867V2.05867H11.4242H5.57505H5.32505V2.30867V2.46542C5.32505 2.94792 4.93219 3.34077 4.44969 3.34077C3.9672 3.34077 3.57434 2.94792 3.57434 2.46542V2.30867V2.05867H3.32434H2.84977C1.48874 2.05867 0.381965 3.16558 0.381965 4.52657V6.05863V6.30863H0.631965H16.3674ZM12.5496 0.77643C12.0802 0.77643 11.6987 1.15794 11.6987 1.62727V2.46539C11.6987 2.93477 12.0802 3.31623 12.5496 3.31623C13.0189 3.31623 13.4004 2.93472 13.4004 2.46539V1.62727C13.4004 1.15789 13.0189 0.77643 12.5496 0.77643ZM4.44969 0.77643C3.98031 0.77643 3.59885 1.15794 3.59885 1.62727V2.46539C3.59885 2.93476 3.98032 3.31623 4.44969 3.31623C4.91907 3.31623 5.30054 2.93472 5.30054 2.46539V1.62727C5.30054 1.1579 4.91906 0.77643 4.44969 0.77643Z"
                                                fill="#014D3C"
                                                stroke="#7E7E7E"
                                                stroke-width="0.5"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_4325_19163">
                                                <rect
                                                  width="17"
                                                  height="17"
                                                  fill="white"
                                                />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                        </span>
                                        {appointment?.timeSlot}
                                      </p>
                                      <div
                                        onClick={() =>
                                          handlePayment(
                                            appointment?.status,
                                            appointment?._id,
                                            appointment
                                          )
                                        }
                                        style={{ width: "200px" }}
                                      >
                                        <Link
                                        // to="/coach-details"
                                        >
                                          {appointment?.status == 0
                                            ?(ingerman=="de" ? "Nicht akzeptiert" : "Not Accepted")
                                            : appointment?.status == 1
                                            ? (ingerman=="de" ? "Zahlen" : "Pay")
                                            : appointment?.status == 2
                                            ? (ingerman=="de" ? "Abgelehnt" : "Rejected")
                                            : appointment?.status == 3
                                            ? (ingerman=="de" ? "Zahlen" : "Pay")
                                            : appointment?.status == 4
                                            ?(ingerman=="de" ? "Zahlung erledigt" : "Payment Done") 
                                            : (ingerman=="de" ? "Abgesagt" : "Cancelled") }
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="coach-rate">
                                    <p>
                                      <span>
                                        {appointment?.coach_id?.reviews == 0 ? (
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="22"
                                            height="23"
                                            viewBox="0 0 22 23"
                                            fill="none"
                                          >
                                            <path
                                              d="M11.0002 2.33398L13.8327 8.07232L20.1668 8.99815L15.5835 13.4623L16.6652 19.769L11.0002 16.7898L5.33516 19.769L6.41683 13.4623L1.8335 8.99815L8.16766 8.07232L11.0002 2.33398Z"
                                              fill="#A2AA96"
                                            />
                                          </svg>
                                        ) : (
                                          <svg
                                            width="19"
                                            height="18"
                                            viewBox="0 0 19 18"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M9.16667 0L11.9992 5.73833L18.3333 6.66417L13.75 11.1283L14.8317 17.435L9.16667 14.4558L3.50167 17.435L4.58333 11.1283L0 6.66417L6.33417 5.73833L9.16667 0Z"
                                              fill="#E5A151"
                                            />
                                          </svg>
                                        )}
                                      </span>
                                      {appointment?.coach_id?.reviews}
                                    </p>
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <p
                              style={{
                                textAlign: "center",
                                marginTop: "100px",
                              }}
                            >
                              {ingerman=="de" ? "Keine Daten gefunden" : "Data not found"}
                            </p>
                          )}
                        </div>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </div>
          </div>
        </div>

        {/*===============================Appointment details====================================
        
         */}

        {/* <Modal
          show={show}
          onHide={() => setshow(false)}
          className="delete-popup"
        >
          <Modal.Header style={{ textAlign: "center" }} closeButton>
            <Modal.Title>
              <h3>Requested Details</h3>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>

          { reviewData?.data?.map((review)=>{
            return (
              <div className="review-card">
              <div className="review-view">
                <div className="review-pro">
                  <img
                    src={`${BASE_URL}${review?.user_id?.profile_image}`}
                  />
                  <h3>{review?.user_id?.full_name}</h3>
                </div>

                
                  <div className="review-rate">
                    <p>
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                        >
                          <path
                            d="M9.23509 1.76562L11.4163 6.18445L16.2939 6.89739L12.7645 10.335L13.5974 15.1915L9.23509 12.8974L4.87274 15.1915L5.70568 10.335L2.17627 6.89739L7.05392 6.18445L9.23509 1.76562Z"
                            fill="#F5B715"
                          />
                        </svg>
                      </span>
                      {review?.rating}
                    </p>
                  </div>
                
              </div>
              <p>{review?.review}</p>
              <p>{moment(review?.createdAt).format("DD MMMM YYYY")} at {moment(review?.createdAt).format("hh:mm A")}</p>
            </div>

            )
          })}
          
          </Modal.Body>
        </Modal> */}
      </LayoutNew>
    </>
  );
}
